import React from 'react';
import { useTranslation } from 'react-i18next';
import FormTextField from '../../../../antd/form/FormTextField/FormTextField.jsx';
import { required } from '../../../../antd/form/FormValidation.js';
import FormSwitch from '../../../../antd/form/FormSwitch/FormSwitch.jsx';
import FormButton from '../../../../antd/form/FormButton/FormButton.jsx';
import FormButtonsContainer from '../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import Form from '../../../../antd/form/Form/Form.jsx';
import { Button, Col, Row, Tooltip } from 'antd';
import { CollapseBlock } from '../../../../common/index.jsx';
import { CopyOutlined, InfoCircleOutlined } from '@ant-design/icons';

const YellowBookForm = ({
  initials,
  isEdit,
  onSubmit,
  onGenerateClick,
  onTemporaryGenerateClick,
}) => {
  const { t } = useTranslation();

  const tooltipTemporaryText = (
    <p>
      {t(
        'Generovať dočasné PDF je možné len pre mňa. Ak potrebujete generovať PDF pre iných používateľov, použite tlačidlo',
      )}
      &nbsp;
      <b>{t('Generovať PDF')}</b>.{' '}
      {t(
        'Dočasné PDF sa generuje len pre mňa a nie je dostupné pre ostatných používateľov.',
      )}
    </p>
  );

  const tooltipText = (
    <p>
      {t(
        'Generované PDF sa uloží do systému a bude dostupné pre všetkých používateľov. Dostupné bude len cez odkaz odkiaľ sa bude môcť zobraziť alebo stiahnuť. Ak potrebujete generovať PDF len pre seba, použite tlačidlo',
      )}
      &nbsp;
      <b>{t('Generovať dočasné PDF (len pre mňa)')}</b>.{' '}
      {t('Proces generovania PDF môže trvať niekoľko minút.')}
    </p>
  );

  return (
    <Form onFinish={onSubmit} initialValues={initials}>
      <CollapseBlock title={t('Informácie')}>
        <Row gutter={[16, 0]}>
          <Col span={10}>
            <FormTextField
              label={t('Názov (slovensky)')}
              name={'title'}
              rules={[required(t)]}
            />
          </Col>
          <Col span={10}>
            <FormTextField label={t('Názov (anglicky)')} name={'title_en'} />
          </Col>
          <Col span={4}>
            <FormSwitch label={t('Zobrazená')} name={'visible'} />
          </Col>
        </Row>
        {/* <Row>
          <Col span={4}>
            <FormSwitch label={t('Archivovaná')} name={'archived_at'} />
          </Col>
        </Row> */}
      </CollapseBlock>
      <CollapseBlock title={t('Nastavenia')}>
        <Row gutter={16}>
          <Col span={8}>
            <FormTextField
              label={t('Veľkosť písma textu (pt)')}
              name={['settings', 'fontSizeText']}
              type={'number'}
            />
          </Col>
          <Col span={8}>
            <FormTextField
              label={t('Veľkosť písma nadpisu (pt)')}
              name={['settings', 'fontSizeHeader']}
              type={'number'}
            />
          </Col>
          <Col span={8}>
            <FormTextField
              label={t('Veľkosť písma v tabuľke (pt)')}
              name={['settings', 'fontSizeTable']}
              type={'number'}
            />
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={6}>
            <FormTextField
              label={t('Odsadenie stránky zhora (pt)')}
              name={['settings', 'marginTop']}
              type={'number'}
            />
          </Col>
          <Col span={6}>
            <FormTextField
              label={t('Odsadenie stránky sprava (pt)')}
              name={['settings', 'marginRight']}
              type={'number'}
            />
          </Col>
          <Col span={6}>
            <FormTextField
              label={t('Odsadenie stránky zospodu (pt)')}
              name={['settings', 'marginBottom']}
              type={'number'}
            />
          </Col>
          <Col span={6}>
            <FormTextField
              label={t('Odsadenie stránky zľava (pt)')}
              name={['settings', 'marginLeft']}
              type={'number'}
            />
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={6}>
            <FormTextField
              label={t('Odsadenie hlavičky (pt)')}
              name={['settings', 'marginHeader']}
              type={'number'}
            />
          </Col>
          <Col span={6}>
            <FormTextField
              label={t('Odsadenie pätičky (pt)')}
              name={['settings', 'marginFooter']}
              type={'number'}
            />
          </Col>
        </Row>
      </CollapseBlock>
      {isEdit && (
        <CollapseBlock
          title={t('Generovanie PDF súboru (len s uloženými zmenami)')}
        >
          <Row gutter={[16, 0]}>
            <Col span={8}>
              <Button onClick={onTemporaryGenerateClick}>
                {t('Generovať dočasné PDF (len pre mňa)')}
              </Button>
              &nbsp;
              <Tooltip title={tooltipTemporaryText} placement="top">
                <InfoCircleOutlined />
              </Tooltip>
            </Col>
            <Col span={4}>
              <Button onClick={onGenerateClick}>{t('Generovať PDF')}</Button>
              &nbsp;
              <Tooltip title={tooltipText} placement="top">
                <InfoCircleOutlined />
              </Tooltip>
            </Col>
            <Col span={8}>
              <FormTextField name={'pdf_path'} disabled />
            </Col>
            <Col span={3}>
              <Button
                onClick={() => {
                  navigator.clipboard.writeText(initials['pdf_path']);
                }}
              >
                <CopyOutlined />
                {t('Kopírovať odkaz')}
              </Button>
            </Col>
          </Row>
        </CollapseBlock>
      )}
      <FormButtonsContainer>
        <FormButton submitOnClick={true} submitKey={'yellowBooks'}>
          {t('Uložiť')}
        </FormButton>
      </FormButtonsContainer>
    </Form>
  );
};

export default YellowBookForm;
